import Carousels from "../Componentes/Carousels";
import Nosotros from "../Componentes/Nosotros";


function Home(){
    return(
        <>
            <Carousels/>
            <Nosotros/>

        </>
    )
}

export default Home;